/*
 * File per la definizione delle direttive Angular:
 * https://code.angularjs.org/1.5.8/docs/guide/directive
 */
define([
    'angular'
],
    function (angular) {
        var formDirectives = angular.module('formDirectives', []);

        /*
         * Direttiva per l'inserimento del Captcha all'interno di un FORM
         */
        formDirectives.directive('captcha', ['$sce', 'CONSTANTS', captcha]);

        function captcha($sce, CONSTANTS) {

            var urlArgs = CONSTANTS.URL_ARGS;
            return {
                replace: true,
                /*
                 * Direttiva di tipo Elemento (tag HTML)
                 */
                restrict: 'E',
                templateUrl: 'resources/html/includes/directives/captcha.html' + urlArgs,
                scope: {
                    form: '=',
                    inputCaptcha: '=',
                    initFn: '&'
                },
                controller: ['$scope', '$log', '$timeout', function ($scope, $log, $timeout) {

                    var src = CONSTANTS.PATH_CAPTCHA;
                    $scope.config = {
                        reset: function () {
                            $scope.inputCaptcha = null;
                        },
                        loadImg: function () {
                            $scope.config.srcImg = src + "?type=image&v=" + new Date().getTime();
                            $scope.config.reset();
                        },
                        loadAudio: function (reload) {

                            var playAudio = function () {
                                angular.element("#audio-captcha")[0].play();
                            }

                            var setAudio = function () {
                                $scope.config.srcAudio = "";
                                $scope.config.srcAudio = src + "?type=audio&v=" + new Date().getTime();
                                $scope.config.reset();
                                angular.element("#input-captcha").focus();
                                /*
                                 * Aggiungo un timeout per dare il tempo all'audio di essere caricato
                                 * e al lettore di schermo di leggere la label del campo di input
                                 */
                                $timeout(playAudio, 3000);
                            };

                            if (reload) {
                                $scope.config.loadImg();
                                /*
                                 * Aggiungo un timeout per dare il tempo all'immagne di essere generata
                                 * e creare il codice corretto in sessione
                                 */
                                $timeout(setAudio, 1000);
                            } else {
                                setAudio();
                            }
                        },
                    };

                    $scope.config.loadImg();
                    $scope.config.reset();
                    /*
                     * Inizializzo il paramentro loadImg utilizzato esternamente dal Controller con la funzione interna loadImg
                     */
                    $scope.initFn({ loadImg: $scope.config.loadImg });
                }]
            };
        }

        return formDirectives;
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/directives/form-directives.js
// module id = 37
// module chunks = 1